const resolveLink = page => {
  if (!page) return null

  const { _type, seo } = page

  const slug = seo?.slug.current || ''

  switch (_type) {
    case 'servicesPg': return `/services/${ slug }`
    case 'expertisePg': return `/expertise/${ slug }`
    case 'altEnergyPg': return `/expertise/alternative-energy/${ slug }`
    case 'hvacPg': return `/expertise/commercial-hvac/${ slug }`
    case 'productsPg': return `/products/${ slug }`
    default: return `/${ slug }`
  }
}

export default resolveLink
